import { STOCK_ENGINE } from "../app/Config";


export function isStockEntityFifoEngine() {
    return STOCK_ENGINE === "STOCK_ENTITY_FIFO";
}

export function isSqlAvgEngine() {
    return STOCK_ENGINE === "SQL_AVG";
}